<template>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">应急作战指挥中事件</div>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0rem;">
        <div class="zj-search-result-table">
          <label class="labelname">应急中事件共 {{eventLength}} 件</label>
          <el-table :data="tableData" @row-click="rowclick" :show-header="false">
            <el-table-column>
              <template slot-scope="scope">
                <ComponentInfoPanel
                  type="EmergencyIncidentStorage"
                  v-bind:info="convert(scope.$index,scope.row)"
                  :currentDate="currentDate"
                ></ComponentInfoPanel>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </zj-layout-main>
    </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import ComponentInfoPanel from "./Component-InfoPanel";
const utils = ZJApp.ZJUtils;
import { list } from "@/api/src/emergency_event";
export default {
  name: "ZJEmergencyIncidentList",
  controller: "UI",
  action: "EmergencyIncidentList",
  components: {
    ComponentInfoPanel: ComponentInfoPanel
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      tableData: [],
      eventLength: 0,
      FitEventTypeDic: [],
      EventLevelDic: [],
      currentDate: new Date()
    };
  },
  created: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index: index,
        ...row
      };
      return result;
    },
    search() {
      let searchInfo = {
        Status: 4, //应急中状态
        size: 200,
        current: 1,
      };
      this.loading = true;
      this.loadingText = '加载中...';
      list(searchInfo)
        .then(r => {
          r = r.data.records;
          this.tableData = r;
          this.eventLength = this.tableData.length;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.zj-search-result-table .labelname{
    padding-top: 0.5rem;
    padding-left: 3rem;
    padding-bottom: 1.5rem;
}
</style>